import React from 'react';
import { WEIGHTS, SIZE, TYPOGRAPHY_COLOR_TYPES } from '../globalTypes';
import { getTypographyStyles } from './styleUtils';

export interface TypographyProps {
	children: React.ReactNode;
	type?: 'text' | 'display' | 'h1' | 'h2' | 'h3';
	size?: SIZE;
	weight?: WEIGHTS;
	color?: TYPOGRAPHY_COLOR_TYPES;
	className?: string;
}

export const Typography: React.FC<TypographyProps> = ({
	children,
	type = 'text',
	size = 'md',
	weight = 'regular',
	color = 'default',
	className
}) => {
	const styles = getTypographyStyles(size, weight, type, color);
	return (
		<span className={className} style={styles}>
			{children}
		</span>
	);
};
